export const zzeehBaseURL = "https://api.zzeehweddings.com/api/zzeeh";

export const momentsBaseURL = "https://api.zzeehweddings.com/api/moments";

export const clienthubBaseURL = "https://api.zzeehweddings.com/api/clienthub";

export const nexusBaseURL = "https://api.zzeehweddings.com/api/nexus";

// export const zzeehBaseURL = "http://localhost:8000/api/zzeeh";

// export const momentsBaseURL = "http://localhost:8000/api/moments";

// export const clienthubBaseURL = "http://localhost:8000/api/clienthub";

// export const nexusBaseURL = "http://localhost:8000/api/nexus";

export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const authEmails = [
  "syed.zain4401@gmail.com",
  "info@zzeeh.com",
  "zubair@zzeeh.com",
  "shaistha@zzeeh.com",
  "mudassir@zzeeh.com",
  "zain@zzeeh.com",
];
